<template>
	<section class="mt-16 py-8 md:py-16 bg-gray-50">
        <div class="w-full max-w-screen-xl mx-auto px-6">
            <div class="md:flex md:justify-center space-y-8 md:space-y-0">

                <div class="flex md:block justify-between items-center w-full md:w-1/3 pr-0 md:pr-4 md:pl-4 text-left md:text-center">
                    <img src="/media/icons/icon-hammer.svg" class="h-12 w-12 mb-0 md:mb-4 mr-4 block md:mx-auto" />
                    <div class="flex-grow">
                        <div class="font-bold mb-2 md:mb-0 uppercase">{{ __('home::index.usp_1_title') }}</div>
                        <div>{{ __('home::index.usp_1_description') }}</div>
                    </div>
                </div>

                <div class="flex md:block justify-between items-center w-full md:w-1/3 pl-0 md:pl-4 md:pr-4 text-left md:text-center">
                    <img src="/media/icons/icon-pakke.svg" class="h-12 w-12 mb-0 md:mb-4 mr-4 block md:mx-auto" />
                    <div class="flex-grow">
                        <div class="font-bold mb-2 md:mb-0 uppercase">{{ __('home::index.usp_2_title') }}</div>
                        <div>{{ __('home::index.usp_2_description') }}</div>
                    </div>
                </div>

                <div class="flex md:block justify-between items-center w-full md:w-1/3 px-1 md:px-4 text-left md:text-center" v-if="$page.props.__media_folder == 'fototiles.dk'">
                    <img src="/media/icons/icon-dk.svg" class="h-12 w-12 mb-0 md:mb-4 mr-4 block md:mx-auto" />
                    <div class="flex-grow">
                        <div class="font-bold mb-2 md:mb-0 uppercase">{{ __('home::index.usp_3_title') }}</div>
                        <div>{{ __('home::index.usp_3_description') }}</div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>